import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { IconButton, Stack } from '@mui/material';

import { Box, Grid, Icon, Paper, Typography } from '@mui/material';
import GenericModal from 'components/GenericModal';
import MDTypography from 'components/MDTypography/index';
import PingPongText from 'components/PingPongText/PingPongText';
import { useState } from 'react';
import { SeverityColor, SeverityIcon } from 'types/severity';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const SensorAlert = props => {
  const [open, setOpen] = useState(false);
  const [showSensorId] = useState(props.showSensorId === undefined || props.showSensorId === true);
  // console.log("_________", showSensorId);

  const getPaperIcon = () => {
    const alertSeverity = {
      Reconnected: 3,
      Disconnected: 1,
      'Bad Air Quality - High Co2': 0,
      'Bad Air Quality - High Pm2.5': 0,
      'Bad Air Quality - High Pm10': 0,
      'Bad - Uncomfortable Enviorment': 0,
      'Bad Air Quality - High TVOC': 0,
      'Bad Air Quality - High NOx': 0,
      'Bad Comfort level': 0,
      'Moderate Air Quality - Co2': 1,
      'Moderate Air Quality - Pm2.5': 1,
      'Moderate Air Quality - Pm10': 1,
      'Moderate - Uncomfortable Enviorment': 1,
      'Moderate Air Quality - TVOC': 1,
      'Moderate Air Quality - NOx': 1,
      'Moderate Comfort level': 1,
    };

    const severityIndex = alertSeverity[props.description] !== undefined ? alertSeverity[props.description] : 2;
    return (
      <Paper
        color={'white'}
        className="alertIcon"
        style={{
          background: `linear-gradient(160deg, ${SeverityColor[severityIndex]?.[0]}, ${SeverityColor[severityIndex]?.[1]}`,
        }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingBottom: 0,
          width: '2.5rem',
          height: '2.5rem',
          boxShadow: 'none',
        }}>
        <Icon fontSize="large">{SeverityIcon[1]}</Icon>
      </Paper>
    );
    // }

    return (
      <Paper
        color={'white'}
        elevation={3}
        style={{
          background: `linear-gradient(160deg, ${SeverityColor[props.severity][0]}, ${SeverityColor[props.severity][1]}`,
        }}
        sx={{
          paddingTop: 1,
          paddingX: 1.2,
          marginTop: -3.5,
          marginBottom: 0.5,
          marginRight: 1.25,
          position: 'absolute',
        }}>
        <Icon fontSize="small">{SeverityIcon[props.severity]}</Icon>
      </Paper>
    );
  };

  // console.log("props.alertTimes:", props.alertTimes);

  const formatDateRange = (start, end) => {
    // Parse the input date strings as Date objects (in UTC)
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Helper function to pad numbers with a leading zero if needed
    function pad(num) {
      return num.toString().padStart(2, '0');
    }

    // Extract and pad the hours, minutes, day, and month from the start date (using UTC)
    const startHours = pad(startDate.getUTCHours());
    const startMinutes = pad(startDate.getUTCMinutes());
    const startDay = pad(startDate.getUTCDate());
    const startMonth = pad(startDate.getUTCMonth() + 1); // Months are zero-indexed

    // Extract and pad the hours, minutes, day, and month from the end date (using UTC)
    const endHours = pad(endDate.getUTCHours());
    const endMinutes = pad(endDate.getUTCMinutes());
    const endDay = pad(endDate.getUTCDate());
    const endMonth = pad(endDate.getUTCMonth() + 1);

    if (startDay === endDay && startMonth === endMonth && startDate.getUTCFullYear() === endDate.getUTCFullYear()) {
      return `${startHours}:${startMinutes} - ${endHours}:${endMinutes} (${startDay}.${startMonth})`;
    }

    // Return the formatted string: "HH:mm DD.mm - HH:mm DD.mm"
    return `${startHours}:${startMinutes} (${startDay}.${startMonth}) - ${endHours}:${endMinutes} (${endDay}.${endMonth})`;
  };

  const getDateRangeParts = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    function pad(num) {
      return num.toString().padStart(2, '0');
    }

    const startHours = pad(startDate.getUTCHours());
    const startMinutes = pad(startDate.getUTCMinutes());
    const startDay = pad(startDate.getUTCDate());
    const startMonth = pad(startDate.getUTCMonth() + 1);
    const endHours = pad(endDate.getUTCHours());
    const endMinutes = pad(endDate.getUTCMinutes());
    const endDay = pad(endDate.getUTCDate());
    const endMonth = pad(endDate.getUTCMonth() + 1);
    const isSameDate = startDay === endDay && startMonth === endMonth && startDate.getUTCFullYear() === endDate.getUTCFullYear();

    return {
      startTime: `${startHours}:${startMinutes}`,
      endTime: `${endHours}:${endMinutes}`,
      startDate: `${startDay}.${startMonth}`,
      endDate: `${endDay}.${endMonth}`,
      isSameDate,
    };
  };

  const groupRangesByDate = ranges => {
    return ranges.reduce((acc, range) => {
      const rangeParts = getDateRangeParts(range.start, range.end);
      const groupKey = rangeParts.isSameDate
        ? rangeParts.startDate
        : `${rangeParts.startTime}-${rangeParts.endTime}-${rangeParts.startDate}-${rangeParts.endDate}-${range.start_unix}`;
      const existingGroup = acc.find(group => group.key === groupKey);
      const displayTime = rangeParts.isSameDate
        ? `${rangeParts.startTime} - ${rangeParts.endTime}`
        : `${rangeParts.startTime} - ${rangeParts.endTime}`;

      if (existingGroup) {
        existingGroup.ranges.push({ ...range, displayTime });
        return acc;
      }

      acc.push({
        key: groupKey,
        dateLabel: rangeParts.isSameDate ? rangeParts.startDate : null,
        startDateLabel: rangeParts.isSameDate ? null : rangeParts.startDate,
        endDateLabel: rangeParts.isSameDate ? null : rangeParts.endDate,
        ranges: [{ ...range, displayTime }],
      });

      return acc;
    }, []);
  };

  const handleTimeRangesClick = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const groupedAlertTimes = groupRangesByDate(Array.isArray(props.alertTimes) ? props.alertTimes : []);

  const modalTitle = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: '100%',
      }}>
      {getPaperIcon()}
      <Box sx={{ minWidth: 0 }}>
        {showSensorId && (
          <MDTypography fontSize={14} fontWeight="bold" color="inherit" textAlign="start">
            {props.sensorId ?? ''}
          </MDTypography>
        )}
        <MDTypography variant="body2" color="inherit" fontSize={16}>
          <PingPongText text={props.description ?? ''} />
        </MDTypography>
      </Box>
    </Box>
  );

  const TimeRangesContent = () => (
    <Box
      className="ranges-container"
      sx={{
        width: 'fit-content',
        minWidth: 'min(18rem, calc(100vw - 32px))',
        maxWidth: 'calc(100vw - 32px)',
        maxHeight: '30rem',
        overflowY: 'auto',
        overflowX: 'visible',
      }}>
      {groupedAlertTimes.map((row, index) => (
        <Box
          key={row.key}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            borderBottom: index === groupedAlertTimes.length - 1 ? 'none' : '1px solid rgb(202, 202, 202)',
            padding: '10px 12px',
            color: '#000',
            maxWidth: 'calc(100vw - 32px)',
            overflowX: 'hidden',
          }}>
          {row.dateLabel && (
            <Typography component="span" sx={{ minWidth: '3.5rem', fontSize: 16, fontWeight: 600, color: '#000' }}>
              {row.dateLabel}
            </Typography>
          )}
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1.5,
              flexWrap: 'wrap',
              minWidth: 0,
              maxWidth: '100%',
            }}>
            {row.ranges.map((rangeObj, rangeIndex) => (
              <Typography
                key={`${rangeObj.start_unix}-${rangeIndex}`}
                component="span"
                sx={{ fontSize: 16, color: '#000', whiteSpace: 'nowrap' }}>
                {row.startDateLabel ? (
                  <>
                    {rangeObj.displayTime.split(' - ')[0]}{' '}
                    <Box component="span" sx={{ fontWeight: 700 }}>
                      ({row.startDateLabel})
                    </Box>
                    {' - '}
                    {rangeObj.displayTime.split(' - ')[1]}{' '}
                    <Box component="span" sx={{ fontWeight: 700 }}>
                      ({row.endDateLabel})
                    </Box>
                  </>
                ) : (
                  rangeObj.displayTime
                )}
              </Typography>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );

  return (
    <Paper sx={{ width: { xs: '100%', lg: '40rem' }, marginBottom: '.7rem', borderRadius: '.5rem' }}>
      {/* <Grid container py={0.2} px={1} my={0.5} alignItems="center"> */}

      <Grid container wrap="nowrap" py={0.8} px={1} sx={{ height: '4rem', gap: 0.5, flexWrap: 'nowrap' }} alignItems="center">
        <Grid sx={{ flex: '0 0 auto' }}>{getPaperIcon()}</Grid>
        <Grid sx={{ flex: '1 1 0', minWidth: 0 }}>
          <Stack
            className="title-time-container"
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ width: '100%', minWidth: 0, flexWrap: 'nowrap', overflow: 'hidden' }}>
            {showSensorId ? (
              <Grid item sx={{ flex: '0 1 auto', minWidth: 0, maxWidth: '40%' }}>
                <MDTypography fontSize={14} fontWeight="bold" color="inherit" textAlign="start" noWrap>
                  {props.sensorId ?? ''}
                </MDTypography>
              </Grid>
            ) : (
              <></>
            )}
            <Box
              sx={{
                flex: '1 1 0',
                minWidth: 0,
                overflow: 'hidden',
                padding: '.3rem .5rem',
              }}>
              <MDTypography variant="body2" color="inherit" fontSize={16} sx={{ fontSize: { xs: '.9rem', sm: '1rem' } }}>
                <PingPongText text={props.description ?? ''} />
              </MDTypography>
            </Box>
            <Box
              sx={{
                flex: '0 0 auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}>
              {props.alertTimes.length !== 1 ? (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <MDTypography
                    variant="body2"
                    color="inherit"
                    fontSize={24}
                    mx={1}
                    // mt={0.5}
                  >
                    {props.alertsNum}
                  </MDTypography>
                  {/* <AccessTimeIcon sx={{ scale: "1.2", marginBottom: "-21px" }} /> */}
                  <AccessTimeIcon sx={{ scale: '1.2' }} mt={0.5} />

                  <IconButton fontSize="medium" style={{ color: 'black' }} onClick={handleTimeRangesClick}>
                    <OpenInNewIcon />
                  </IconButton>
                </Box>
              ) : (
                <MDTypography
                  fontSize={14} // was 18
                  sx={{ position: 'relative' }} // Remove right: "-3rem"
                  // fontWeight="bold"
                  color="inherit"
                  textAlign="center"
                  width="fit-content"
                  // border="2px solid red"
                >
                  {formatDateRange(props.alertTimes[0].start, props.alertTimes[0].end)}
                </MDTypography>
              )}
            </Box>
          </Stack>
        </Grid>
        <GenericModal
          open={open}
          onClose={handleClose}
          title={modalTitle}
          Component={TimeRangesContent}
          closeOnBackdrop={true}
          closeOnEsc={true}
          contentProps={{
            dividers: true,
            sx: {
              overflowY: 'auto',
              p: 0,
            },
          }}
        />
      </Grid>
    </Paper>
  );
};
